import React, { Component } from 'react';
import { Flex, Heading, Icon, Text } from 'core/components';
import Collapse from 'core/components/Collapse';
import PropTypes from 'prop-types';

class DrawerSection extends Component {
  static propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    defaultOpen: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func
  };

  static defaultProps = {
    defaultOpen: false,
    disabled: false,
    onChange: () => {}
  };

  state = {
    open: false
  };

  constructor(props) {
    super(props);

    // eslint-disable-next-line react/state-in-constructor
    this.state = {
      open: props.defaultOpen
    };
  }

  componentDidUpdate(prevProps) {
    const { defaultOpen, disabled } = this.props;
    const { open } = this.state;

    if (disabled && !prevProps.disabled && open) {
      // collapse the drawer when disabled
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ open: false });
      return;
    }

    if (defaultOpen !== prevProps.defaultOpen) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ open: defaultOpen });
    }
  }

  toggleOpen = () => {
    const { disabled, onChange } = this.props;

    if (disabled) {
      return;
    }

    this.setState(
      ({ open }) => ({
        open: !open
      }),
      () => {
        const { open } = this.state;
        onChange(open);
      }
    );
  };

  render() {
    const { children, label, headerProps, disabled, ...props } = this.props;
    const { open } = this.state;

    return (
      <>
        <Heading
          level={6}
          mb={1}
          fontWeight="heavy"
          borderBottom="thin"
          onClick={disabled ? undefined : this.toggleOpen}
          aria-disabled={disabled}
          style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
          {...headerProps}
        >
          <Flex gap={1}>
            <Icon color="muted" icon={open ? 'caret-down' : 'caret-right'} />
            <Text width="100%">{label}</Text>
          </Flex>
        </Heading>
        <Collapse isOpen={open} {...props}>
          {children}
        </Collapse>
      </>
    );
  }
}

export default DrawerSection;
